import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import jwtService from 'app/services/jwtService';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';

import { setUserData, logoutUser } from './store/userSlice';

function handleLoginWithAccess(userId) {
  return jwtService
    .signInWithAccess(userId)
    .then((user) => ({ user }))
    .catch((error) => ({ error: error.message }));
}

function handleLoginWithToken() {
  return jwtService
    .signInWithToken()
    .then((user) => ({ user }))
    .catch((error) => {
      if (error?.status === 4000) jwtService.logout();

      return { error: error.message };
    });
}

function Auth(props) {
  const [state, setState] = useState({ waitAuthCheck: true });
  const dispatch = useDispatch();

  useEffect(() => {
    async function handleAutoLogin(userId) {
      if (userId) {
        // TODO: Remove this commit after Connect V1 is deprecated
        const { user, error } = await handleLoginWithAccess(userId);
        if (user) dispatch(setUserData(user));
        if (error) dispatch(showMessage({ message: error }));
      } else {
        const { user, error } = await handleLoginWithToken();
        if (user) dispatch(setUserData(user));
        if (error) dispatch(showMessage({ message: error }));
      }

      setState({ waitAuthCheck: false });
    }

    function handleAutoLogout(message) {
      if (message) {
        dispatch(showMessage({ message }));
      }

      dispatch(logoutUser());

      setState({ waitAuthCheck: false });
    }

    function handleNoAccessToken() {
      setState({ waitAuthCheck: false });
    }

    jwtService.on('onAutoLogin', handleAutoLogin);
    jwtService.on('onAutoLogout', handleAutoLogout);
    jwtService.on('onNoAccessToken', handleNoAccessToken);

    jwtService.init();

    return () => {
      jwtService.removeListener('onAutoLogin', handleAutoLogin);
      jwtService.removeListener('onAutoLogout', handleAutoLogout);
      jwtService.removeListener('onNoAccessToken', handleNoAccessToken);
    };
  }, [dispatch]);

  return state.waitAuthCheck ? <FuseSplashScreen /> : props.children;
}

export default Auth;
